<template>
	<div>

		<div class="container-fluid">
			<div class="row no-gutters mt-2 reports">
				<div class="col-sm-6 align-items-center">
					<div class="border mr-1 mb-1 p-3 report-item">
						<h6 class="">Project Certainty Index</h6>
						<ProjectGauge :data="certainty_index" :fillBackground="$report.color(certainty_index.value)" />
					</div>
				</div>
				<div class="col-sm-6">
					<div class="border ml-1 mb-1 p-3 report-item">
						<h6 class="">Zone Time Breakdown</h6>
						<ProjectZoneTime :data="project_zone_time_data"/>
					</div>
				</div>
			</div>

			<div class="row no-gutters mt-2 reports">

				<div class="col-sm-6">
					<div class="border mr-1 mt-1 p-3 report-item mini-charts">
						<div class="row no-gutters">
							<div class="col-sm-4"><h6 class="">Checkup</h6></div>
							<div class="col-sm-5 small text-center text-muted">Project Trend</div>
							<div class="col-sm-3 small text-muted text-nowrap">Current Week ({{moment(week.start).format('M/D')}} - {{moment(week.end).format('M/D')}})</div>
						</div>

						<div class="row no-gutters border p-1 mb-3">
							<div class="col-sm-4 text-right pr-5 align-self-center">Safety Certainty Index</div>
							<div class="col-sm-5 chart-item">
								<transition name="fade">
									<ProjectHistoryGauge :data="safety_index" v-if="safety_index.length" />
									<div class="mini-graph" v-else></div>
								</transition>
								<small class="empty-text" v-if="safety_index.length === 0">
									{{empty_text}}
								</small>
							</div>
							<div class="col-sm-3 chart-item">

								<ProjectIndexGauge :data="safety_index_week" :centered="true" :fillBackground="$report.color(safety_index_week.value)" />

							</div>
						</div>


						<div class="row no-gutters border p-1 mb-3">
							<div class="col-sm-4 text-right pr-5 align-self-center">First Starts</div>
							<div class="col-sm-5 chart-item">
								<transition name="fade">
									<ProjectHistoryGauge :data="first_start_index" v-if="first_start_index.length" />
									<div class="mini-graph" v-else></div>
								</transition>
								<small class="empty-text" v-if="first_start_index.length === 0">
									{{empty_text}}
								</small>
							</div>
							<div class="col-sm-3 chart-item">
								<ProjectIndexGauge :data="first_start_index_week" :centered="true" :fillBackground="$report.color(first_start_index_week.value)" />
							</div>
						</div>


						<div class="row no-gutters border p-1 mb-3">
							<div class="col-sm-4 text-right pr-5 align-self-center">Mustering Efficiency</div>
							<div class="col-sm-5 chart-item">
								<transition name="fade">
									<ProjectHistoryGauge :data="mustering_efficiency" v-if="mustering_efficiency.length" />
									<div class="mini-graph" v-else></div>
								</transition>
								<small class="empty-text" v-if="mustering_efficiency.length === 0">
									{{empty_text}}
								</small>
							</div>
							<div class="col-sm-3 chart-item">
								<ProjectIndexGauge :data="mustering_efficiency_week" :centered="true" :fillBackground="$report.color(mustering_efficiency_week.value)" />
							</div>
						</div>


						<div class="row no-gutters border p-1 mb-3">
							<div class="col-sm-4 text-right pr-5 align-self-center">Time in Work Zone</div>
							<div class="col-sm-5 chart-item">
								<transition name="fade">
									<ProjectHistoryGauge :data="time_in_work_zone_index" v-if="time_in_work_zone_index.length" />
									<div class="mini-graph" v-else></div>
								</transition>
								<small class="empty-text" v-if="time_in_work_zone_index.length === 0">
									{{empty_text}}
								</small>
							</div>
							<div class="col-sm-3 chart-item">

								<ProjectIndexGauge :data="time_in_work_zone_index_week" :centered="true" :fillBackground="$report.color(time_in_work_zone_index_week.value)" />
							</div>
						</div>

					</div>
				</div>
				<div class="col-sm-6">
					<div class="border ml-1 mt-1 p-3 report-item clearfix icon-box">
						<h6 class="">Reports</h6>
						<a v-b-modal="'mustering-report-modal'" href="#" @click.prevent="" class="border">
							<img class="img-fluid mr-3" src="~/assets/img/icons/muster-icon.png"
								 alt="Mustering Report">
							Emergency Mustering Report
						</a>
						<a v-b-modal="'fall-report-modal'" href="#" class="border">
							<img class="img-fluid mr-3" src="~/assets/img/icons/fall-icon.png" alt="Mustering Report">
							Fall / Man Down Report
						</a>
						<a v-b-modal="'zone-violation-report-modal'" href="#" class="border">
							<img class="img-fluid mr-3" src="~/assets/img/icons/restricted-zone-violation-icon.png"
								 alt="Mustering Report">
							Critical Zone Violation Report
						</a>
						<a v-b-modal="'work-zone-report-modal'" href="#" class="border">
							<img class="img-fluid mr-3" src="~/assets/img/icons/work-icon.png" alt="Mustering Report">
							Work Zone Summaries
						</a>
					</div>
				</div>

			</div>
		</div>

		<MusteringReport/>
		<ZoneViolationReport/>
		<FallReport/>
		<WorkZoneReport/>

	</div>
</template>

<style scoped lang="scss" rel="stylesheet/scss">
	.reports {
		.report-item {
			min-height: 330px;
			height: 100%;
		}
	}

	.icon-box {
		a {
			width: 300px;
			text-decoration: none;
			height: 40px;
			display: inline-block;
			padding: 5px;
			margin-right: 5px;
			margin-bottom: 5px;
			img {
				max-height: 100%;
			}
		}
	}

	.chart-item {
		height: 64px;
		position: relative;
	}
	.empty-text {
		line-height: 1.4;
		display: none;
		margin-top: 5px;
		padding-right: 20px;
	}

	.mini-graph {
		width: 87px;
		height: 40px;
		background: #ccc;
		position: absolute;
		top: 0;
		&.centered {
			left: 50%;
			margin-left: -43.5px;
		}
	}
</style>

<script>

	import ProjectGauge from '../../components/Views/Reports/ProjectGauge';
	import ProjectHistoryGauge from '../../components/Views/Reports/ProjectHistoryGauge';
	import ProjectZoneTime from '../../components/Views/Reports/ProjectZoneTime';
	import MusteringReport from '../../components/Views/Reports/MusteringReport';
	import ZoneViolationReport from '../../components/Views/Reports/ZoneViolationReport';
	import FallReport from '../../components/Views/Reports/FallReport.vue';
	import WorkZoneReport from '../../components/Views/Reports/WorkZoneReport.vue';
	import ProjectIndexGauge from '../../components/Views/Reports/ProjectIndexGauge';


	export default {
		name: 'Project',
		data() {
			return {
				empty_text: 'Not enough data available to accurately produce graph. At least full day of records are necessary.',
			}
		},
		computed: {
			workers() { return this.$store.state.workers },
			log() { return this.$store.state.log },
			watcher() {
				return this.$store.state.watcher
			},
			alert() {
				return this.$store.state.alert
			},
			time() {
				return this.$store.state.time
			},
			start_time() {
				return this.$config.start_time
			},
			end_time() {
				return this.$config.end_time
			},
			extended() {
				return this.$store.state.bottom_menu_collapsed
			},
			day() { return this.$store.state.day },
			start_date() { return this.$store.state.start_date },
			week() {
				let end = this.moment(this.start_date).add(this.day - 1, 'days');
				let start = this.moment(end).subtract(7, 'days').format();

				start = this.moment.max(this.moment(start), this.moment(this.start_date));

				return {start: start, end: end}
			},
			week_range() {
				return [this.day - 6, this.day];
			},
			safety_index() {
				return this.$store.state.report.safety;
			},
			safety_index_week() {
				return {value: this.$finder.avg(this.safety_index.slice(this.week_range))};
			},
			mustering_efficiency() {
				return this.$store.state.report.mustering;
			},
			mustering_efficiency_week() {
				return {value: this.$finder.avg(this.mustering_efficiency.slice(this.week_range))};
			},
			time_in_work_zone_index() {
				return this.$store.state.report.time_in_work_zone || [];
			},
			time_in_work_zone_index_week() {
				return {value: this.$finder.avg(this.time_in_work_zone_index.slice(this.week_range))};
			},
			first_start_index() {
				return this.$store.state.report.first_starts;
			},
			first_start_index_week() {
				return {value: this.$finder.avg(this.first_start_index.slice(this.week_range))};
			},
			certainty_index() {
				return this.$store.state.report.certainty_index;
			},
			project_zone_time_data() {
				return this.$store.state.report.project_zone_time;
			}
		},
		components: {
			ProjectZoneTime,
			ProjectGauge,
			ProjectHistoryGauge,
			MusteringReport,
			ZoneViolationReport,
			FallReport,
			WorkZoneReport,
			ProjectIndexGauge
		}
	}
</script>
